import PropTypes from 'prop-types'
import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

import { AuthLayoutView } from '../AuthLayout'
import {
  BrandHeader,
  BrandTitle,
  BrandSubtitle,
  AuthSection,
  HelpSection,
  HelpText,
  HelpSpan,
  LegalLinks,
  LoginButton,
} from './KindeLogin.styled.js'
import { isDrayNowHost } from '../../../../lib/config/multitenancy'

function KindeLoginView({
  // Logic hook results
  isLoading,
  isAutoLogin,
  privacyUrl,
  termsUrl,
  handleKindeLogin,
}) {
  const isDrayNow = isDrayNowHost()

  if (isAutoLogin) {
    return (
      <AuthLayoutView isDrayNow={isDrayNow}>
        <Dimmer active inverted>
          <Loader size='medium'>Redirecting...</Loader>
        </Dimmer>
      </AuthLayoutView>
    )
  }

  // Theme-specific configuration
  const themeConfig = isDrayNow
    ? {
        welcomeTitle: 'Welcome to DrayNow!',
        tagline: 'Log in to track, manage, and optimize your moves.',
      }
    : {
        welcomeTitle: 'Welcome to ModalView!',
        tagline: 'Log in to track, manage, and optimize your moves.',
      }

  return (
    <AuthLayoutView isDrayNow={isDrayNow}>
      <div data-testid='login-form-container'>
        <BrandHeader>
          <BrandTitle>{themeConfig.welcomeTitle}</BrandTitle>
          <BrandSubtitle>{themeConfig.tagline}</BrandSubtitle>
        </BrandHeader>

        <AuthSection>
          <LoginButton
            disabled={isLoading}
            onClick={handleKindeLogin}
            primary
            fluid
            data-testid='login-kinde-submit-btn'
          >
            Log In
          </LoginButton>
        </AuthSection>

        <HelpSection>
          <HelpText $isDrayNow={isDrayNow}>
            By logging in, you are agreeing to our
          </HelpText>
          <LegalLinks>
            <a
              href={privacyUrl}
              target='_blank'
              rel='noopener noreferrer'
              data-testid='login-kinde-privacy-link'
            >
              Privacy Policy
            </a>
            <HelpSpan $isDrayNow={isDrayNow}> & </HelpSpan>
            <a
              href={termsUrl}
              target='_blank'
              rel='noopener noreferrer'
              data-testid='login-kinde-terms-link'
            >
              Terms of Service
            </a>
          </LegalLinks>
        </HelpSection>
      </div>
    </AuthLayoutView>
  )
}

KindeLoginView.propTypes = {
  // Props from logic hook
  isLoading: PropTypes.bool.isRequired,
  isAutoLogin: PropTypes.bool.isRequired,
  privacyUrl: PropTypes.string.isRequired,
  termsUrl: PropTypes.string.isRequired,
  handleKindeLogin: PropTypes.func.isRequired,
}

export { KindeLoginView }
